<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="lyleft">
        <start-end ref="startEnd" timeModel="2,3"></start-end>
        <ly-form-item
          label="派单类型"
          style="width: 160px; margin-left: 15px; line-height: 30px"
          ><Select v-model="orderType">
            <Option
              v-for="(x, index) in $t('orderType')"
              :value="index"
              :key="index"
              >{{ x }}</Option
            >
          </Select></ly-form-item
        ><Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>

      <div id="ddas">
        <Button @click="openAdd" type="primary" size="small">新增派遣</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="pic">
        <viewer>
          <img
            v-for="(x, index) in row.beforeImgList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="chakan(row, index)">分派</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增事件' : '编辑事件'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; position: relative">
        <point ref="point" @address="item.address = $event"></point>
        <div style="width:280px" id="dewewcsleceeww">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="项目名称" prop="groupId">
                  <selectItems
                    :name="item.groupName"
                    @update:name="item.groupName = $event"
                    :id="item.groupId"
                    @update:id="item.groupId = $event"
                  ></selectItems>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="业务类型" prop="businessType">
                  <Select v-model="item.businessType">
                    <Option
                      v-for="(x, index) in $t('businessType')"
                      :value="x"
                      :key="index"
                      >{{ x }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="事件来源" prop="source">
                  <Select v-model="item.source">
                    <Option
                      v-for="(x, index) in $t('source')"
                      :value="x"
                      :key="index"
                      >{{ x }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="事件内容" prop="content">
                  <Input v-model="item.content" placeholder="请输入"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="图片" prop="beforeImgList">
                  <ly-photo
                    ref="lyphoto"
                    v-model="item.beforeImgList"
                  ></ly-photo>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <div class="btn-wrap">
                  <Button @click="resetForm">重置表单</Button>
                  <Button type="primary" @click="next('item')">下一步</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
    <chakan ref="chakan" @success="getList"></chakan>
    <Modal v-model="openAddress" title="确认派遣地址" footer-hide width="400">
      <Form ref="address" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="派遣地址" prop="address">
              <Input
                v-model="item.address"
                type="textarea"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="getAdd">重新获取</Button>
              <Button type="primary" @click="addUpdate('address')"
                >完成提交</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import chakan from "./chakan.vue";
import point from "../map/point.vue";
export default {
  components: { chakan, point },
  data() {
    return {
      openForm: false,
      openAddress: false,
      isAdd: false,
      axios: axios,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "事件编码",
          key: "no",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 300,
          maxWidth: 350,
        },
        {
          title: "事件内容",
          key: "content",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "事件来源",
          key: "source",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务类型",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "附件",
          slot: "pic",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: 6,
        businessType: "清扫保洁",
        source: "巡检上报", //员工上报,呼叫工单,巡检上报,数字化城管)
        address: "事件地址",
        content: "",
        beforeImgList: [],
        x: 114.125348,
        y: 22.673121,
      },
      ruleValidate: {
        content: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        beforeImgList: { required: true, message: "必填" },
      },

      pageNumber: 1,
      pageSize: 50,
      total: 0,
      orderType: "0",
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      var params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        groupId: "",
        businessType: "",
        source: "",
        keyWork: "",
        orderType: this.orderType, //	派单类型:-1-所有,0-事件派单,1-复核派单
        startTime: this.timeObj.start,
        endTime: this.timeObj.end,
        no: "",
      };
      console.log(params);
      axios({
        method: "post",
        url: axios.event + "/event/dispatchList",
        data: params,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var ccc = this.$refs.point.getPoint();
      //this.item.address = ccc.address;
      this.item.x = ccc.x;
      this.item.y = ccc.y;
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.event + "/event/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.openAddress=false;
                this.getList();
              }
            });
          } else {
            return;
            axios({
              method: "post",
              url: axios.dm + "/carType/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.event + "/event/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
      this.$refs.point.drawMap();
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
      this.$refs.lyphoto.reset();
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    reTimeObj(x) {
      this.timeObj = x;
      //this.getList();
    },
    chakan(v) {
      this.$refs.chakan.open(v);
    },
    chaxun() {
      this.timeObj = this.$refs.startEnd.getTimeObj();
      this.getList();
    },
    next(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.openAddress = true;
          if (this.isAdd) {
            this.getAdd();
          }
        }
      });
    },
    getAdd(name) {
      var ccc = this.$refs.point.getPoint();
      this.item.x = ccc.x;
      this.item.y = ccc.y;

      var pointList = [
        {
          x: this.item.x,
          y: this.item.y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.item.address = data[0].address;
        console.log(this.item);
      });
    },
    shaixuan() {},
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
#dewewcsleceeww {
  position: absolute;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/event/paiqian.vue